import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path stroke="currentColor" strokeWidth="2" d="M12 5v14M5 12h14" /></svg>;